import { Lock } from "lucide-react";

/** Bandeau « Tâche clôturée » — remplace la zone de saisie ; « Rouvrir » visible seulement avec le droit. */
export default function ClosedTaskBanner({ closedAt, closedBy, canReopen, onReopen }) {
  const d = closedAt ? new Date(closedAt).toLocaleDateString("fr-FR", { day: "2-digit", month: "2-digit", year: "numeric" }) : "—";
  return (
    <div className="flex items-center" style={{ gap: 10, padding: "10px 14px", background: "#16161a", border: "0.5px solid #2f2f36", borderRadius: 10 }} data-testid="td-closed-banner">
      <Lock size={15} style={{ color: "#8b8b93", flexShrink: 0 }} />
      <span style={{ fontSize: 12.5, color: "#c8c8cf", flex: 1 }} data-testid="td-closed-banner-text">
        Tâche clôturée le <b style={{ color: "#f2f2f5" }}>{d}</b> par <b style={{ color: "#f2f2f5" }}>{closedBy || "—"}</b> — rouvrez-la pour agir
      </span>
      {canReopen && (
        <button type="button" onClick={onReopen} style={{ fontSize: 12, padding: "6px 14px", borderRadius: 8, border: "0.5px solid #3568B0", color: "#7fb4ec", background: "transparent" }} data-testid="td-reopen">
          Rouvrir
        </button>
      )}
    </div>
  );
}
